<!--
 * @Author: wh
 * @Date: 2020-07-03 11:10:22
 * @LastEditTime: 2026-06-29 12:43:18
 * @LastEditors: DY
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud_Mobile\src\views\salesTerminal\retailAccount\fileUpload.vue
-->
<template>
    <div class="fileUpload">
        <van-nav-bar :title="title" left-text="" left-arrow @click-left="onClickLeft"></van-nav-bar>
        <section class="van-pull-refresh">
            <div class="upload-con">
                <van-uploader
                    multiple
                    preview-image
                    preview-full-image
                    v-model="fileList"
                    :before-read="uploadFileBefore"
                    :after-read="uploadFileMethod"
                    @delete="deleteFile"
                    :show-upload="true"
                    :deletable="!isView"
                    :disabled="isView"
                    :class="{'is-view': isView}"
                ></van-uploader>
            </div>
        </section>
    </div>
</template>

<script>
import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';

export default {
    beforeRouteEnter(to, from, next) {
        next(vm => { vm.parentPath = from.name; });
    },
    components: {},
    props: {},
    mixins: [mixin_fileUpload],
    data() {
        return {
            // 表单数据
            formData: {},
            // 流程实例id
            BusinessInstanceId: '',
            // 只读
            isView: false,
            // 标题
            title: '',
            parentPath: '',
            fileDataId: '',
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.parentPath,
                params: { formData: this.formData, actionType: 'uploadFile' },
            });
        },
    },
    created() {
        this.fileDataId = this.BusinessInstanceId = this.$route.params.BusinessInstanceId;
        this.isView = this.$route.params.isView || false;
        this.formData = this.$route.params.formData;
        this.title = this.$route.params.title;
        this.getFileList();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.fileUpload
    .van-pull-refresh
        height 100%
        .upload-con
            height 100%
            padding 15rpx
            .van-uploader__wrapper--disabled
                opacity 1
            .is-view
                .van-uploader__upload
                    display none
            .van-uploader__preview
                background rgba(240,240,240,1)
                display flex
                justify-content center
                .van-uploader__preview-image
                    vertical-align top
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
</style>
